import styled from 'styled-components'

export const ClinicalEvaluationContainer = styled.div`
    background: ${props => props.passed ? '#f6ffed' : '#ffeee5'};
    color: ${props => props.passed ? '#000' : '#f50'};
    padding: 20px;
    border-radius: 5px;
`